import React from "react";
import Topbar from "../../components/topbar/topbar";
import Footer from "../../components/footer/footer";
import { Link } from "react-router-dom";
import "./terms.css";
import { useTranslation, Trans } from "react-i18next";
export default function TermsAndConditions() {
  const { t } = useTranslation("legalTerms");
  return (
    <>
      <Topbar />
      <div>
        <h1 className="single-title page-title entry-title">
          {t("page.title")}
        </h1>
        <div className="terms-container">
          <div className="terms-wrapper">
            <p className="terms-date">{t("page.date")}</p>

            <div>
              <h2 className="main-title">{t("s1.title")}</h2>
              <p className="title-desc mt-30">
                <Trans i18nKey="s1.p1" ns="legalTerms" components={{ strong: <strong /> }} />
              </p>

              <p className="title-desc mt-40">
                <Trans i18nKey="s1.p2" ns="legalTerms" components={{ link1: <Link to="/privacy-policy" /> }} />
              </p>
              <p className="title-desc">
                {t("s1.p3")}
              </p>
              <p className="title-desc">
                {t("s1.p4")}
              </p>
            </div>
            <div>
              <h2 className="main-title">{t("s2.title")}</h2>
              <p>
                {t("s2.p1")}
              </p>
              <p>
                {t("s2.p2")}
              </p>
            </div>

            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s3.title")}
              </h2>
              <p>
                {t("s3.p1")}
              </p>
              <div className="elementor-widget-container">
                <p>{t("s3.p2")}</p>
                <ul>
                  <li>
                    {t("s3.list1.i1")}
                  </li>
                  <li>
                    {t("s3.list1.i2")}
                  </li>
                </ul>
              </div>

              <div className="elementor-widget-container">
                <p>
                  <Trans i18nKey="s3.p3" ns="legalTerms" components={{ link1: <Link to="/privacy-policy" /> }} />
                </p>
              </div>
              <div className="elementor-widget-container">
                <p>
                  {t("s3.p4")}
                </p>
                <p>
                  <Trans i18nKey="s3.p5" ns="legalTerms" components={{ span1: <span style={{ fontWeight: "400" }} />, link1: <a href="mailto:concerns@verysoul.com" /> }} />
                </p>
              </div>

              <div className="elementor-widget-container">
                <h2 className="elementor-heading-title elementor-size-default">
                  {t("s4.title")}
                </h2>
                <p>
                  {t("s4.p1")}
                </p>
                <p>
                  {t("s4.p2")}
                </p>
                <p>
                  {t("s4.p3")}
                </p>
              </div>
              <div className="elementor-widget-container">
                <ul>
                  <li>
                    {t("s4.list1.i1")}
                  </li>

                  <li>
                    {t("s4.list1.i2")}
                  </li>

                  <li>
                    {t("s4.list1.i3")}
                  </li>

                  <li>
                    {t("s4.list1.i4")}
                  </li>

                  <li>
                    {t("s4.list1.i5")}
                  </li>
                </ul>
              </div>
              <div className="elementor-widget-container">
                {t("s4.p4")}
                <br />
                <br />
                <ul>
                  <li>
                    {t("s4.list2.i1")}
                  </li>
                  <li>
                    {t("s4.list2.i2")}
                  </li>
                  <li>
                    {t("s4.list2.i3")}
                  </li>
                  <li>
                    {t("s4.list2.i4")}
                  </li>
                  <li>
                    {t("s4.list2.i5")}
                  </li>
                  <li>
                    {t("s4.list2.i6")}
                  </li>
                  <li>
                    {t("s4.list2.i7")}
                  </li>
                </ul>
              </div>
              <p>
                {t("s4.p5")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-5d88941a elementor-widget elementor-widget-heading"
            data-id="5d88941a"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s5.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-fbe6df0 elementor-widget elementor-widget-text-editor"
            data-id="fbe6df0"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s5.p1")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-6e27131 elementor-widget elementor-widget-heading"
            data-id="6e27131"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s6.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-45afc13f elementor-widget elementor-widget-text-editor"
            data-id="45afc13f"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s6.p1")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-1b5443e8 elementor-widget elementor-widget-text-editor"
            data-id="1b5443e8"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <ul>
                <li>
                  {t("s6.list1.i1")}
                </li>

                <li>
                  {t("s6.list1.i2")}
                </li>

                <li>
                  {t("s6.list1.i3")}
                </li>

                <li>
                  {t("s6.list1.i4")}
                </li>

                <li>
                  {t("s6.list1.i5")}
                </li>

                <li>
                  {t("s6.list1.i6")}
                </li>
              </ul>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-48d239eb elementor-widget elementor-widget-text-editor"
            data-id="48d239eb"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>{t("s6.p2")}</p>
              <br />
              <br />
              <ul>
                <li>
                  {t("s6.list2.i1")}
                </li>

                <li>
                  {t("s6.list2.i2")}
                </li>

                <li>
                  {t("s6.list2.i3")}
                </li>

                <li>
                  {t("s6.list2.i4")}
                </li>

                <li>
                  {t("s6.list2.i5")}
                </li>

                <li>
                  {t("s6.list2.i6")}
                </li>

                <li>
                  {t("s6.list2.i7")}
                </li>

                <li>
                  {t("s6.list2.i8")}
                </li>
              </ul>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-841a76c elementor-widget elementor-widget-heading"
            data-id="841a76c"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s7.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-c33393 elementor-widget elementor-widget-text-editor"
            data-id="c33393"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                <Trans i18nKey="s7.p1" ns="legalTerms" components={{ strong: <strong /> }} />
              </p>
              <p>
                <span>
                  {t("s7.p2")}
                </span>
              </p>
              <p>
                {t("s7.p3")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-2665fa9 elementor-widget elementor-widget-text-editor"
            data-id="2665fa9"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>{t("s7.p4")}</p>
              <ul>
                <li>
                  {t("s7.list1.i1")}
                </li>
                <li>
                  {t("s7.list1.i2")}
                </li>
              </ul>
              <p>
                {t("s7.p5")}
                <br />
                <br />
              </p>
              <p>
                {t("s7.p6")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-50dfc654 elementor-widget elementor-widget-heading"
            data-id="50dfc654"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s8.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-2504924b elementor-widget elementor-widget-text-editor"
            data-id="2504924b"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>{t("s8.p1")}</p>
              <ul>
                <li>
                  {t("s8.list1.i1")}
                </li>
                <li>
                  {t("s8.list1.i2")}
                </li>
                <li>
                  {t("s8.list1.i3")}
                </li>
                <li>
                  {t("s8.list1.i4")}
                </li>
                <li>
                  {t("s8.list1.i5")}
                </li>
              </ul>
              <div>
                <span>
                  <p>
                    <Trans i18nKey="s8.p2" ns="legalTerms" components={{ link1: <a href="mailto:concerns@verysoul.com" /> }} />
                  </p>
                  {t("s8.p3")}
                </span>
              </div>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-438c9a88 elementor-widget elementor-widget-text-editor"
            data-id="438c9a88"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s8.p4")}
              </p>
              <p>
                {t("s8.p5")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-76097434 elementor-widget elementor-widget-heading"
            data-id="76097434"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s9.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-264e7e26 elementor-widget elementor-widget-text-editor"
            data-id="264e7e26"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                <span>
                  {t("s9.p1")}
                </span>
              </p>
              <p>
                <span>
                  {t("s9.p2")}
                </span>
              </p>
              <p>
                <span>
                  {t("s9.p3")}
                </span>
              </p>
              <p>
                <span>{t("s9.p4")}</span>
              </p>
              <p>
                <span>
                  {t("s9.p5")}
                </span>
              </p>
              <p>
                <span>
                  {t("s9.p6")}
                </span>
              </p>
              <p>
                <span>
                  {t("s9.p7")}
                </span>
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-62b3fbc2 elementor-widget elementor-widget-heading"
            data-id="62b3fbc2"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s10.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-48f2eb8f elementor-widget elementor-widget-text-editor"
            data-id="48f2eb8f"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s10.p1")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-5375458 elementor-widget elementor-widget-text-editor"
            data-id="5375458"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <ul>
                <li>
                  {t("s10.list1.i1")}
                </li>
                <li>
                  {t("s10.list1.i2")}
                </li>
                <li>
                  {t("s10.list1.i3")}
                </li>
                <li>
                  <Trans i18nKey="s10.list1.i4" ns="legalTerms" components={{ link1: <Link to="/privacy-policy" /> }} />
                </li>
                <li>{t("s10.list1.i5")}</li>
                <li>
                  {t("s10.list1.i6")}
                </li>
                <li>
                  {t("s10.list1.i7")}
                </li>
                <li>
                  {t("s10.list1.i8")}
                </li>
                <li>
                  {t("s10.list1.i9")}
                </li>
              </ul>
              <p>
                {t("s10.p2")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-79d2394c elementor-widget elementor-widget-heading"
            data-id="79d2394c"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s11.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-531410c8 elementor-widget elementor-widget-text-editor"
            data-id="531410c8"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                <Trans i18nKey="s11.p1" ns="legalTerms" components={{ span1: <span style={{ textDecoration: "underline" }} />, link1: <a href="mailto:concerns@verysoul.com" /> }} />
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-19701cc2 elementor-widget elementor-widget-heading"
            data-id="19701cc2"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s12.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-17059fe0 elementor-widget elementor-widget-text-editor"
            data-id="17059fe0"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                <span>
                  {t("s12.p1")}
                </span>
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-61bc050b elementor-widget elementor-widget-text-editor"
            data-id="61bc050b"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s12.p2")}
              </p>
              <p>
                {t("s12.p3")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-17993502 elementor-widget elementor-widget-heading"
            data-id="17993502"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s13.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-39767f62 elementor-widget elementor-widget-text-editor"
            data-id="39767f62"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s13.p1")}
              </p>
              <p>
                <Trans i18nKey="s13.p2" ns="legalTerms" components={{ strong: <strong /> }} />
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-21262ef0 elementor-widget elementor-widget-heading"
            data-id="21262ef0"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s14.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-45de267d elementor-widget elementor-widget-text-editor"
            data-id="45de267d"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                <Trans i18nKey="s14.p1" ns="legalTerms" components={{ link1: <Link to="/privacy-policy" />, span1: <span /> }} />
              </p>
              <p>
                <Trans i18nKey="s14.p2" ns="legalTerms" components={{ link1: <Link to="/privacy-policy" />, span1: <span /> }} />
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-3479ff58 elementor-widget elementor-widget-heading"
            data-id="3479ff58"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s15.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-4f9b541d elementor-widget elementor-widget-text-editor"
            data-id="4f9b541d"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s15.p1")}
                <br />
                {t("s15.p2")}
                <br />
                <br />
              </p>
              <ul>
                <li>
                  {t("s15.list1.i1")}
                </li>

                <li>
                  {t("s15.list1.i2")}
                </li>

                <li>
                  {t("s15.list1.i3")}
                </li>
              </ul>
              <p>
              {t("s15.p3")}
              </p>
              <br />
              <br />
              <ul>
                <li>
                  {t("s15.list2.i1")}
                </li>

                <li>
                  {t("s15.list2.i2")}
                </li>

                <li>
                  {t("s15.list2.i3")}
                </li>

                <li>
                  {t("s15.list2.i4")}
                </li>
              </ul>
              <p>
                {t("s15.p4")}
                <br />
                <br />
                {t("s15.p5")}
                <br />
                <br />
                {t("s15.p6")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-fcf744f elementor-widget elementor-widget-heading"
            data-id="fcf744f"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s16.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-6d93a061 elementor-widget elementor-widget-text-editor"
            data-id="6d93a061"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s16.p1")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-594af1e1 elementor-widget elementor-widget-heading"
            data-id="594af1e1"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s17.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-21166082 elementor-widget elementor-widget-text-editor"
            data-id="21166082"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s17.p1")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-28f4eea0 elementor-widget elementor-widget-heading"
            data-id="28f4eea0"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s18.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-7c0c30f4 elementor-widget elementor-widget-text-editor"
            data-id="7c0c30f4"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s18.p1")}
              </p>
              <p>
                {t("s18.p2")}
              </p>
              <p>
                {t("s18.p3")}
              </p>
              <p>
                {t("s18.p4")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-61d214d0 elementor-widget elementor-widget-heading"
            data-id="61d214d0"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s19.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-795c0c66 elementor-widget elementor-widget-text-editor"
            data-id="795c0c66"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s19.p1")}
              </p>
              <p>
                {t("s19.p2")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-2b4b7ba7 elementor-widget elementor-widget-heading"
            data-id="2b4b7ba7"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s20.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-3bbecb39 elementor-widget elementor-widget-text-editor"
            data-id="3bbecb39"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s20.p1")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-222e3cce elementor-widget elementor-widget-heading"
            data-id="222e3cce"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s21.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-2b70cba2 elementor-widget elementor-widget-text-editor"
            data-id="2b70cba2"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                <Trans i18nKey="s21.p1" ns="legalTerms" components={{ mark: <mark /> }} />
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-7096c2da elementor-widget elementor-widget-heading"
            data-id="7096c2da"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s22.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-798370b elementor-widget elementor-widget-text-editor"
            data-id="798370b"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s22.p1")}
              </p>
              <p>
                {t("s22.p2")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-598be347 elementor-widget elementor-widget-heading"
            data-id="598be347"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s23.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-75d48bd2 elementor-widget elementor-widget-text-editor"
            data-id="75d48bd2"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s23.p1")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-6838a663 elementor-widget elementor-widget-heading"
            data-id="6838a663"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s24.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-4cbc1105 elementor-widget elementor-widget-text-editor"
            data-id="4cbc1105"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s24.p1")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-3f506353 elementor-widget elementor-widget-heading"
            data-id="3f506353"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s25.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-75e1d79c elementor-widget elementor-widget-text-editor"
            data-id="75e1d79c"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s25.p1")}
              </p>
              <p>
                {t("s25.p2")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-8a36e3f elementor-widget elementor-widget-heading"
            data-id="8a36e3f"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s26.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-4a455f34 elementor-widget elementor-widget-text-editor"
            data-id="4a455f34"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                {t("s26.p1")}
              </p>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-663259ba elementor-widget elementor-widget-heading"
            data-id="663259ba"
            data-element_type="widget"
            data-widget_type="heading.default"
          >
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">
                {t("s27.title")}
              </h2>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-3f47dda4 elementor-widget elementor-widget-text-editor"
            data-id="3f47dda4"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div className="elementor-widget-container">
              <p>
                <Trans i18nKey="s27.p1" ns="legalTerms" components={{ mark: <mark /> }} />
              </p>
              <p>
                <Trans i18nKey="s27.p2" ns="legalTerms" components={{ span1: <span style={{ textDecoration: "underline" }} />, strong: <strong />, link1: <a href="mailto:concerns@verysoul.com" /> }} />
              </p>
              <p>
                <Trans i18nKey="s27.p3" ns="legalTerms" components={{ strong: <strong />, span1: <span style={{ textDecoration: "underline" }} />, link1: <a href={process.env.REACT_APP_SUPPORT_URL} target="_blank" /> }} />
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
